export const LiteratureReflection = {
  title: 'Literature Reflection',
  icon: '/static/templates_icons/LiteratureReflection.svg',
  prompt: `
    <p class="pink-selectable">
      [Learn more about how to implement this activity in your classroom at
      <a target="_blank" href="https://parlayideas.com/templates/#literature-reflection">https://parlayideas.com/templates/#literature-reflection</a>]
    </p>
    <h3>Introduction</h3>
    <p>
      The purpose of this discussion is for each one of us to complete a post-reading reflection of
      <span class="pink-selectable">[name of book / chapter / other written work]</span>, and then to compare our own reflections to those of our classmates.
    </p>
    <h3>Part 1 - Personal Submission</h3>
    <p>
      In your personal submission write a two paragraph response, answering one of the following
      questions. Point to specific examples in the text where possible.
    </p>
    <p class="pink-selectable">
      [Teacher to choose one or more of these questions, or create another question that encourages
      students to reflect on their own personal experience reading the novel, and to provide their own
      text-supported opinion.]
    </p>
    <p>
      &emsp;<strong>1. &nbsp; What do you think the author wants you to learn from reading this story?</strong>
    </p>
    <p>
      &emsp;<strong>2. &nbsp; How does one of the characters remind you of yourself, another character
      or someone you know?</strong>
    </p>
    <p>
      &emsp;<strong>3. &nbsp; What is the main conflict in the story? Can you relate to the main character’s
      conflicts or problems? Why or why not?</strong>
    </p>
    <p>
      &emsp;<strong>4. &nbsp; Which character do you like the most? Why? Which character do you like the least? Why?</strong>
    </p>
    <p>
      &emsp;<strong>5. &nbsp; What passage in the book is the most memorable to you? Why?</strong>
    </p>
    <p>
      &emsp;<strong>6. &nbsp; If you could interview the author, what would you want to know?</strong>
    </p>
    <p>
      &emsp;<strong>7. &nbsp; Are there any quotes or passages in the book that inspire you? Which ones?
      Why? </strong>
    </p>
    <p>
      &emsp;<strong>8. &nbsp; Do the characters or events connect to people or events in our world? How?</strong>
    </p>
    <h3>Part 2 - Peer Feedback</h3>
    <p>
      After you've submitted your response, comment on at least <span class="pink-selectable">two</span> of your peers' submissions,
      answering the guided feedback questions provided. Try your best to comment on submissions
      that don’t yet have any feedback.
    </p>
  `,
};


// WEBPACK FOOTER //
// ./src/app/components/modals/New_RoundTable/EditorMCE/Templates/Defaults/LiteratureReflection.js